import { Link2Off } from "lucide-react";

/**
 * Shown when /catalog/:slug does not resolve to a live store (404).
 */
export default function CatalogNotFoundModal({ open, language = "ar", slug = "", onGoHome }) {
  if (!open) return null;

  const isAr = language !== "en";
  const title = isAr ? "الرابط غير موجود" : "Link not found";
  const message = isAr
    ? "يبدو أن الرابط الذي تبحث عنه غير صحيح، أو أن هذا الكتالوج غير موجود أو لم يُفعّل بعد."
    : "It looks like the link you're looking for is incorrect, or this catalog doesn't exist or hasn't been activated yet.";
  const hint = slug
    ? isAr
      ? `الرابط: /catalog/${slug}`
      : `Link: /catalog/${slug}`
    : null;
  const homeLabel = isAr ? "الصفحة الرئيسية" : "Go to homepage";

  return (
    <div
      className="catalog-not-found-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="catalog-not-found-title"
    >
      <div
        className="catalog-not-found-modal"
        style={{ direction: isAr ? "rtl" : "ltr" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="catalog-not-found-modal__icon" aria-hidden>
          <Link2Off size={36} strokeWidth={2} />
        </div>
        <h2 id="catalog-not-found-title" className="catalog-not-found-modal__title">
          {title}
        </h2>
        <p className="catalog-not-found-modal__message">{message}</p>
        {hint ? (
          <p className="catalog-not-found-modal__slug" dir="ltr">
            {hint}
          </p>
        ) : null}
        <button type="button" className="catalog-not-found-modal__btn" onClick={onGoHome}>
          {homeLabel}
        </button>
      </div>
    </div>
  );
}
